import * as types from './types';
import { loading, error, success } from 'State/actions';
import { RESET_PASSWORD_STEP } from '../../helpers/constants';

export const setResetPasswordStep = value => {
  return {
    type: types.LOGIN_SET_RESET_PASSWORD_STEP,
    payload: value,
  };
};
export const setResetPasswordSuccess = value => {
  return {
    type: types.LOGIN_SET_RESET_PASSWORD_SUCCESS,
    payload: value,
  };
};

export const clearPasswordError = value => {
  return {
    type: types.LOGIN_SET_RESET_PASSWORD_CLEAR_ERROR,
  };
};

export const postResetPassword = (model, resetStep) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LOGIN_RESET_PASSWORD_LOADING, true));
    const url =
      resetStep === RESET_PASSWORD_STEP.Step_1_Before_Email
        ? 'Account/ResetPasswordViaEmail'
        : 'Account/ResetPasswordViaEmailNewPassword';
    try {
      await MPWWebApi.postGenericInsertUpdate(url, model);
      const message =
        resetStep === RESET_PASSWORD_STEP.Step_1_Before_Email
          ? 'Reset email successfully sent.  Check your email.'
          : 'Password reset successfully.';
      dispatch(success(types.LOGIN_SET_RESET_PASSWORD_SUCCESS, message));
    } catch (ex) {
      dispatch(error(types.LOGIN_RESET_PASSWORD_POST_ERROR, ex));
    }
    dispatch(loading(types.LOGIN_RESET_PASSWORD_LOADING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/login/state/resetpassword/actions.js